import type {
  IGetBranchCustomersExclusionParams,
  IToggleBranchCreditParams,
  IToggleBranchPurchaseLimitParams,
  IToggleBranchUserDataUpdateParams,
  IUpsertBranchClientExclusionParams,
  IUpsertBranchParams,
} from 'core/model/interfaces/distributors/branches.interface';
import { branchesData } from './branches.data';
import type { IGetBranchesListParams } from './branches.dto';
import {
  mapDtoToBranches,
  mapDtoToGetBranchClientExclusion,
  toBranchDto,
  toToggleCreditDto,
  toTogglePurchaseLimitDto,
  toToggleUserDataUpdateDto,
  toUpsertBranchCustomersExclusion,
} from './branches.mappers';

export const branchesService = {
  getBranches: async (params: IGetBranchesListParams) => {
    const response = await branchesData.getBranches(params);

    return mapDtoToBranches(response);
  },
  updateBranch: async (data: IUpsertBranchParams) => {
    const mappedBody = toBranchDto(data);

    return branchesData.updateBranch(mappedBody);
  },
  toggleBranchPurchaseLimit: async (data: IToggleBranchPurchaseLimitParams) => {
    const mappedBody = toTogglePurchaseLimitDto(data);

    return branchesData.toggleBranchPurchaseLimit(mappedBody);
  },
  toggleBranchCredit: async (data: IToggleBranchCreditParams) => {
    const mappedBody = toToggleCreditDto(data);

    return branchesData.toggleBranchCredit(mappedBody);
  },
  toggleBranchUserDataUpdate: async (data: IToggleBranchUserDataUpdateParams) => {
    const mappedBody = toToggleUserDataUpdateDto(data);

    return branchesData.toggleBranchUserDataUpdate(mappedBody);
  },
  getBranchCustomersExclusion: async (params: IGetBranchCustomersExclusionParams) => {
    const response = await branchesData.getBranchCustomersExclusion(params);

    return mapDtoToGetBranchClientExclusion(response);
  },
  upsertBranchCustomersExclusion: async (params: IUpsertBranchClientExclusionParams) => {
    const formData = toUpsertBranchCustomersExclusion(params);

    const response = await branchesData.upsertBranchCustomersExclusion(params, formData);

    return response;
  },
};
